import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/referralCategoriesReducer";
import rootSaga from "./redux/referralCategoriesSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { ReferralCategoriesModule } from "./ReferralCategoriesModule";

const ReferralCategories = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "referralCategories", rootSaga)}>
      <ErrorBoundary moduleName="regions" {...notifications}>
        <ReferralCategoriesModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default ReferralCategories;
